// Auth utility functions
export const setAuth = (token, user, permissions) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('permissions', JSON.stringify(permissions));
};

export const getAuth = () => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const permissions = JSON.parse(localStorage.getItem('permissions') || 'null');
    
    return { token, user, permissions };
};

export const clearAuth = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
};

export const isAuthenticated = () => {
    return !!localStorage.getItem('token');
};

export const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
    return permissions[permission] === true;
};

